import React, { Component, Fragment } from "react";



import axios from "axios";

import { Table, Container, Row, InputGroup, Col, Navbar, NavbarBrand, Nav, NavItem, NavLink, Card, CardBody, CardTitle, CardSubtitle, CardText, Button, UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem, ButtonGroup, FormGroup, Label, Input } from "reactstrap";
import moment from "moment";
import HeaderComponent from "../header/HeaderComponent";
import Select from "react-select";

import $ from "jquery";
import "datatables.net";
import { is } from "immutable";

const { Base64 } = require("js-base64");

function statusChange(type) {
  const { data } = this.state;
  this.setState({ data: data.set("currentSlamState", type) });
}

function formatBytes(bytes, decimals = 2) {
  if (!+bytes) return "0 Bytes";

  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`;
}
class ProductAllPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedMode: "all",
      showModal: false,
      tableData: [],
      project_list: [],
      selectedData: undefined,
      max_rows: 25,
      currentProject: undefined,
      selectedProjectName: "",
      selectedProjectName: "all",
      onDownloadAll: false,
      downloadProgress: "",
      isDownloadModalOpen: false,
      downloadUrls: [],
      totalFiles: 0,

    };
    statusChange = statusChange.bind(this);
    this.mqttClient = "";
    this.test = React.createRef();
    this.modalRef = React.createRef();
    window.that = this;
  }







  toggleModal = (item) => {

    this.setState({ showModal: !this.state.showModal });
  };


  closeModal = () => {

    this.setState({ isModalOpen: false, modalImageSrc: '', isInfoModalOpen: false });
  };
  onEvalChanged = async (seq, value) => {
    const { data } = this.state;
    const result = await axios({
      method: "Post",
      url: `${this.props.urls[this.props.stage]}/admin/request`,
      data: {
        seq: seq,
        evaluation: value,
      },
      headers: {
        Authorization: this.props.cognito.user.signInUserSession.idToken.jwtToken,
      },
    });
    alert("변경했습니다.");
    this.doShowModal(Base64.encode(JSON.stringify(result.data.data)));
  };
  onValueChanged = (name, value) => {

    console.log("name:", name, ",value:", value)

    this.setState({
      [name]: value

    }, () => {
      if (name == "selectedMode") {
        this.initializeDatatable();
      }
      if (name == "selectedProjectName") {

        this.setState({ currentProject: this.state.project_list.find((item) => item.project_name == value) }, () => { });

        this.initializeDatatable();
      }
    });

  };
  handleClickOutside = (event) => {
    if (this.modalRef.current && !this.modalRef.current.contains(event.target)) {
      this.closeModal();
    }
  };
  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
  }
  getEsmCall = async () => {

    await axios({
      url: `${process.env.REACT_APP_API_PATH}/${process.env.REACT_APP_STAGE}/admin/esm`,
      params: {

      },
      type: "get",
      headers: {
        Authorization: this.props.cognito.user.signInUserSession.idToken.jwtToken,
      },
      error: function (xhr, error, code) {
        console.log(error);
      },
    });



  };
  getDataTableAjax = () => {
    const { data } = this.state;

    let mode = this.state.selectedMode

    if (mode == "diverged") {
      mode = "all";
    }
    return {
      url: `${process.env.REACT_APP_API_PATH}/${process.env.REACT_APP_STAGE}/charan/project/product/datatable?status=${this.state.selectedMode}&project_name=${this.state.selectedProjectName}`,
      type: "get",
      headers: {
        Authorization: this.props.cognito.user.signInUserSession.idToken.jwtToken,
      },
      error: function (xhr, error, code) {
        if (xhr && (xhr.status === 401 || xhr.status === 403)) { alert("권한이 없습니다. 다시 로그인해 주세요."); } else { console.warn("데이터를 불러오지 못했습니다(일시적 오류). 잠시 후 새로고침해 주세요.", xhr && xhr.status); }
      },
    };
  };

  getTaskInfo = async (seq) => {



    const _result = await axios({
      url: `${process.env.REACT_APP_API_PATH}/${process.env.REACT_APP_STAGE}/admin/task/info`,
      params: {
        seq: seq,
      },
      type: "get",
      headers: {
        Authorization: this.props.cognito.user.signInUserSession.idToken.jwtToken,
      },
      error: function (xhr, error, code) {
        if (xhr && (xhr.status === 401 || xhr.status === 403)) { alert("권한이 없습니다. 다시 로그인해 주세요."); } else { console.warn("데이터를 불러오지 못했습니다(일시적 오류). 잠시 후 새로고침해 주세요.", xhr && xhr.status); }
      },
    });
    const result = JSON.parse(_result.data.body);
    this.setState({
      currentTask: result.task,
      currentEnvParm: result.parmenv,
      isInfoModalOpen: true,
    })
  };
  projectCheck = (project_name, type) => {

    if (type === "all") {
      window.open("/product?project_name=" + project_name, "_blank");
    } else {
      window.open("/productone?project_name=" + project_name, "_blank");
    }
  }
  generateImageUrl(item, thumnail) {
    //console.log(item);
    if (!item) {
      return "";
    }
    if (thumnail) {
      return `${process.env.REACT_APP_API_PATH}/${process.env.REACT_APP_STAGE}/public/download/image?project_name=${item.project_name}&seq=${item.seq1}&type=input&version=${item.version}&width=500&height=500`

    }
    return `${process.env.REACT_APP_API_PATH}/${process.env.REACT_APP_STAGE}/public/download/image?project_name=${item.project_name}&seq=${item.seq1}&type=input&version=${item.version}`
  }



  generateResultUrl(item, thumnail) {

    if (!item) {
      return "";
    }
    if (thumnail) {
      return `${process.env.REACT_APP_API_PATH}/${process.env.REACT_APP_STAGE}/public/download/image?project_name=${item.project_name}&seq=${item.seq1}&type=output&width=500&height=500`
    }
    return `${process.env.REACT_APP_API_PATH}/${process.env.REACT_APP_STAGE}/public/download/image?project_name=${item.project_name}&seq=${item.seq1}&type=output`
  }
  generateImageUrl2(item, thumnail) {
    console.log(item);
    if (!item) {
      return "";
    }
    if (thumnail) {
      return `${process.env.REACT_APP_API_PATH}/${process.env.REACT_APP_STAGE}/public/download/image?project_name=${item.project_name}&seq=${item.seq}&type=input&version=${item.version}&width=500&height=500`

    }
    return `${process.env.REACT_APP_API_PATH}/${process.env.REACT_APP_STAGE}/public/download/image?project_name=${item.project_name}&seq=${item.seq}&type=input&version=${item.version}`
  }



  generateResultUrl2(item, thumnail) {

    if (!item) {
      return "";
    }
    if (thumnail) {
      return `${process.env.REACT_APP_API_PATH}/${process.env.REACT_APP_STAGE}/public/download/image?project_name=${item.project_name}&seq=${item.seq}&type=output&width=500&height=500`
    }
    return `${process.env.REACT_APP_API_PATH}/${process.env.REACT_APP_STAGE}/public/download/image?project_name=${item.project_name}&seq=${item.seq}&type=output`
  }
  getCurrentStatus = (status) => {
    if (status == "accept") {
      return `<span style="font-weight:bold; color:green">수락</span>`
    }
    else if (status == "hold") {
      return `<span  style="font-weight:bold; color:orange" }}>보류</span>`
    }
    else if (status == "reject") {
      return `<span style="font-weight:bold; color:red">제외</span>`
    }
    else {
      return `<span  style="font-weight:bold; color:purple">검수 전</span>`
    }
  }
  openModal = async (jsonstr) => {
    const item = JSON.parse(jsonstr);
    const result = await axios({
      method: "Get",
      url: `${process.env.REACT_APP_API_PATH}/${process.env.REACT_APP_STAGE}/charan/project/product/task`,
      params: {
        seq: item.seq1,

      },
      headers: {
        Authorization: this.props.cognito.user.signInUserSession.idToken.jwtToken,
      },
    });
    const task = JSON.parse(result.data.body).task;



    this.setState({
      isModalOpen: true, modalImageSrc: this.generateImageUrl2(task), modalImageSrc2: this.generateResultUrl2(task),
      currentSelectedTask: task
    });
  }
  getColumnSetting = () => {
    const that = this;
    const thumbnailWidth = 75;
    const thumbnailHeight = 75;



    let idx = { title: "idx", data: "idx", searchable: true, className: "dt-center", width: "5%" };

    let project_name = { title: "project_name", data: "project_name", searchable: true, className: "dt-center", width: "5%" };
    let product_id = { title: "project_name", data: "product_id", searchable: true, className: "dt-center", width: "5%" };
    let original_view = {
      title: "원본",
      data: "seq",
      className: "dt-center",
      render: function (data, type, row, meta) {
        //	return `<img  role="button" width=${500} height=${500} onclick="window.that.downloadFile('${row.seq}')"  src='${that.generateImageUrl(row)}'>`;

        return `<img  role="button" width=${500} height=${500}  src='${that.generateImageUrl(row)}'>`;


      },
    };
    let result_view = {
      title: "결과보기",
      data: "seq",
      className: "dt-center",
      render: function (data, type, row, meta) {

        return `<img  role="button" width=${500} height=${500} onclick='window.that.openModal("${JSON.stringify(row).replaceAll('"', '\\"')}")'   src='${that.generateResultUrl(row)}'>`;


      },
    };
    let status = {
      title: "원본",
      data: "seq",
      className: "dt-center",
      render: function (data, type, row, meta) {

        return that.getCurrentStatus(row.customer_check_status)


      },
    };
    let arr = [idx, project_name, product_id, original_view, result_view, status];





    return arr;
  };
  initializeDatatable = () => {
    const that = this;
    const { data } = this.state;
    if (this.oTable) {
      this.oTable.destroy();
      this.test.current.innerHTML = "";
    }
    this.oTable = $(this.test.current).DataTable({
      order: [[0, "desc"]],
      iDisplayLength: this.state.max_rows,
      searching: true,
      processing: true,
      responsive: true,
      language: {
        processing: "Loading...",
      },
      serverSide: true,
      ajax: this.getDataTableAjax(),
      columns: this.getColumnSetting(),
      initComplete: function () {
        $(".dataTables_filter input").unbind();
        $(".dataTables_filter input").bind("keyup", function (e) {
          var code = e.keyCode || e.which;
          if (code == 13) {
            that.oTable.search(this.value).draw();
          }
        });
      },
    });
    $(".dataTables_wrapper").css("width", "100%");
    $("#DataTables_Table_0_length").on("change", function (val) {
      that.setState({ data: data.set("max_rows", parseInt($("#DataTables_Table_0_length  option:selected").text())) });
    });
  };
  refreashTable = (event) => {
    this.initializeDatatable();
  };
  getProjectList = async () => {
    const result = await axios({
      method: "Get",
      url: `${process.env.REACT_APP_API_PATH}/${process.env.REACT_APP_STAGE}/charan/project/list`,
      params: {


      },
      headers: {
        Authorization: this.props.cognito.user.signInUserSession.idToken.jwtToken,
      },
    });
    const projects = JSON.parse(result.data.body).project_list;
    if (projects == undefined) {
      return;
    }
    projects.unshift({ project_name: "all" })
    const searchParams = new URLSearchParams(window.location.search);
    const projectName = searchParams.get("project_name");


    const currentProject = projects.find((item) => item.project_name == projectName)

    this.setState({
      project_list: projects,
      currentProject: currentProject,
      selectedProjectName: (projectName) ? projectName : "all"
      //selectedProjectName: "rlabs_241118"
    }, () => {

      this.initializeDatatable();


    });
  }
  async componentDidMount() {
    document.addEventListener("mousedown", this.handleClickOutside);
    this.getProjectList()


  }
  getModeKor = () => {

    return "전체 목록"
  };


  handleResultClick = (project_name, seq, type) => {
    let url = "";
    if (type == "input") {
      url = this.generateImageUrl(project_name, seq);
    } else if (type == "model") {
      url = this.generateModelUrl(project_name, seq);
    } else if (type == "output") {
      url = this.generateResultUrl(project_name, seq);
    }

    this.setState({ isModalOpen: true, modalImageSrc: url });

  };
  downloadAll = async () => {
    if (this.state.selectedProjectName == "all") {
      alert("다운로드 받을 프로젝트를 선택해주세요.");
      return;
    }
    if (this.state.currentProject.check_status != "completed") {
      if (!window.confirm("전체 다운로드를 진행하시겠습니까? 해당 프로젝트가 완료 상태로 전환되며 이미지를 다운로드 합니다.(완료 상태로 전환된 프로젝트는 검수 상태 변경이 불가능합니다.)")) {
        return;
      }
    }

    const projectName = this.state.selectedProjectName;
    this.setState({ onDownloadAll: true, downloadProgress: "다운로드 준비 중..." });

    // ① 단일 zip(비동기) 우선: start → 몇 초마다 status 확인 → 완성되면 zip 1개 다운로드.
    //    백엔드가 fallback:true 를 주면(self-invoke 권한 없음 등) ② 기존 청크 경로로 자동 전환.
    const authHeader = { Authorization: this.props.cognito.user.signInUserSession.idToken.jwtToken };
    const DOWNLOAD_BASE = process.env.REACT_APP_PROJECT_DOWNLOAD_ALL; // .../lambda/download
    try {
      const startRes = await axios({
        method: 'POST', url: `${DOWNLOAD_BASE}/start`,
        params: { project_name: projectName }, headers: authHeader,
      });
      const startData = JSON.parse(startRes.data.body);
      if (!startData.fallback) {
        // 단일 zip 경로. ready 면 즉시, building 이면 폴링(최대 ~5분).
        for (let i = 0; i < 100; i++) {
          let url = startData.state === 'ready' ? startData.downloadUrl : null;
          if (!url) {
            // eslint-disable-next-line no-await-in-loop
            const stRes = await axios({
              method: 'GET', url: `${DOWNLOAD_BASE}/status`,
              params: { project_name: projectName }, headers: authHeader,
            });
            const st = JSON.parse(stRes.data.body);
            if (st.state === 'ready') url = st.downloadUrl;
          }
          if (url) {
            this.downloadFile(url, `${projectName}.zip`);
            this.setState({ onDownloadAll: false, downloadProgress: "",
              isDownloadModalOpen: true,
              downloadUrls: [{ partNumber: 1, fileName: `${projectName}.zip`, url }],
              totalFiles: 1 });
            return;
          }
          this.setState({ downloadProgress: `압축파일 생성 중... (${i * 3}초)` });
          // eslint-disable-next-line no-await-in-loop
          await new Promise((r) => setTimeout(r, 3000));
        }
        // 5분 넘게 안 끝나면 청크로 폴백(아래로 진행).
        this.setState({ downloadProgress: "대용량 — 분할 다운로드로 전환 중..." });
      }
    } catch (e) {
      // start/status 실패 → 청크 경로로 폴백(회귀 방지).
      console.log('single-zip 실패, 청크로 폴백:', e);
    }

    // ② 폴백: 100장씩 여러 zip (기존 동작).
    const CHUNK = 100;
    try {
      const parts = [];
      let offset = 0;
      let total = null;
      let partIndex = 0;
      do {
        // eslint-disable-next-line no-await-in-loop
        const res = await axios({
          method: 'GET',
          url: `${process.env.REACT_APP_PROJECT_DOWNLOAD_ALL}`,
          params: { project_name: projectName, check_status: "accept", offset, limit: CHUNK },
          headers: {
            Authorization: this.props.cognito.user.signInUserSession.idToken.jwtToken,
          },
        });
        const responseData = JSON.parse(res.data.body);
        if (total === null) total = responseData.totalAccepted || 0;
        const partCount = Math.max(1, Math.ceil((total || 1) / CHUNK));
        partIndex += 1;
        this.setState({ downloadProgress: `파트 준비 중 ${partIndex}/${partCount}...` });
        if (responseData.downloadUrls && Array.isArray(responseData.downloadUrls)) {
          for (const u of responseData.downloadUrls) parts.push(u);
        }
        offset += CHUNK;
      } while (offset < (total || 0));

      if (!parts.length) {
        alert("다운로드할 파일이 없습니다.");
        this.setState({ onDownloadAll: false, downloadProgress: "" });
        return;
      }

      // 자동 다중 다운로드: 각 파트를 약간의 간격을 두고 순차 트리거.
      // 브라우저가 '여러 파일 다운로드를 허용하시겠습니까?'를 한 번 물으면 허용해 주세요.
      for (let i = 0; i < parts.length; i++) {
        this.downloadFile(parts[i].url, parts[i].fileName || `${projectName}-part${i + 1}.zip`);
        // eslint-disable-next-line no-await-in-loop
        await new Promise((r) => setTimeout(r, 800));
      }

      // 혹시 브라우저가 일부를 막을 때 대비해 목록 모달도 띄워 수동 재다운로드가 가능하게.
      this.setState({
        onDownloadAll: false,
        downloadProgress: "",
        isDownloadModalOpen: true,
        downloadUrls: parts,
        totalFiles: parts.reduce((a, p) => a + (p.fileCount || 0), 0),
      });
    } catch (e) {
      alert("다운로드 중 오류가 발생했습니다. 잠시 후 다시 시도하거나 목록에서 개별 다운로드해주세요.");
      console.log(e);
      this.setState({ onDownloadAll: false, downloadProgress: "" });
    }
  };
  closeDownloadModal = () => {
    this.setState({ 
      isDownloadModalOpen: false, 
      downloadUrls: [],
      totalFiles: 0 
    });
  };
  
  downloadFile = (url, fileName) => {
    const link = document.createElement('a');
    link.href = url;
    link.download = fileName;
    link.style.display = 'none';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  
  exportToExcel = async () => {
    if (!this.state.currentProject) {
      alert("액셀 다운로드를 위한 프로젝트를 선택해주세요.")
      return;
    }
    if (this.state.currentProject.check_status != "completed") {
      if (!window.confirm("전체 다운로드를 진행하시겠습니까? 현재 파일 주소를 포함한 액셀파일을 다운로드 할 수 있습니다.(다운로드 준비까지 약간의 시간이 소요됩니다.)")) {

        return;
      }
    }
    try {
      const downloadResult = await axios({
        method: 'GET',
        url: `${process.env.REACT_APP_API_PATH}/${process.env.REACT_APP_STAGE}/charan/project/download/excel`,
        params: {
          project_name: this.state.selectedProjectName,


        },
        headers: {
          Authorization: this.props.cognito.user.signInUserSession.idToken.jwtToken,
        },

      });
      const url = JSON.parse(downloadResult.data.body).downloadUrl;

      window.open(url)
      // this.setState({ currentDownloadUrl: url })
      //this.setState({ onDownloadAll: false })
    }
    catch (e) {
      alert("파일 키가 없거나 올바른 요청이 아닙니다.")
      console.log(e)
    }



  };
  render() {


    //<TableBox options={options} sizeClass={"col-md-6"}></TableBox>
    return (
      <Fragment>
        {this.state.isModalOpen && (
          <div className="modals"
            zIndex={1500}
            style={{

            }} >
            <div className="modal-contents" ref={this.modalRef} style={{ width: "95%", }}>
              <div style={{ width: "100%", fontSize: 25, color: "black", fontWeight: 800, justifyContent: "center", textAlign: "center", marginBottom: "5px" }}></div>

              <div style={{
                width: "100%", display: "flex",

                "justify-content": "space-between"
              }}>
                <img onClick={() => { this.closeModal() }} style={{
                  display: "block",
                  "margin-left": "auto",
                  "margin-right": "auto",
                  "object-fit": "contain",
                  "max-height": 800,
                  "max-width": 500
                }} src={this.state.modalImageSrc} alt="Large version" className="modal-image" />

                {/* <TaskComponent item={this.state.currentSelectedTask}></TaskComponent> */}
                <img onClick={() => { this.closeModal() }} style={{
                  display: "block",
                  "margin-left": "auto",
                  "margin-right": "auto",
                  "object-fit": "contain",
                  "max-height": 800
                }} src={this.state.modalImageSrc2} alt="Large version" className="modal-image" />
                <div>
                  <table style={{ width: "100%", border: "1px solid black", "border-collapse": "collapse" }}>
                    <thead>
                      <tr>
                        <th style={{ width: "70%" }}>Prop</th>
                        <th style={{ width: "50%" }}>Value</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td className="tb_td">ProductId</td>
                        <td className="tb_td">{this.state.currentSelectedTask?.product_id}</td>
                      </tr>
                      <tr>
                        <td className="tb_td">seq</td>
                        <td className="tb_td">{this.state.currentSelectedTask?.seq}</td>
                      </tr>
                      <tr>
                        <td className="tb_td">카테고리</td>
                        <td className="tb_td">{this.state.currentSelectedTask?.category_1}</td>
                      </tr>
                      <tr>
                        <td className="tb_td">Total</td>
                        <td className="tb_td">{this.state.currentSelectedTask?.size_total}</td>
                      </tr>
                      <tr>
                        <td className="tb_td">Hip</td>
                        <td className="tb_td">{this.state.currentSelectedTask?.size_hip}</td>
                      </tr>

                      <tr>
                        <td className="tb_td">Waist</td>
                        <td className="tb_td">{this.state.currentSelectedTask?.size_waist}</td>
                      </tr>
                      <tr>
                        <td className="tb_td">Breast</td>
                        <td>{this.state.currentSelectedTask?.size_breast}</td>
                      </tr>
                      <tr>
                        <td className="tb_td">Sleeve</td>
                        <td className="tb_td">{this.state.currentSelectedTask?.size_sleeve}</td>
                      </tr>
                      <tr>
                        <td className="tb_td">Shoulder</td>
                        <td className="tb_td">{this.state.currentSelectedTask?.size_shoulder}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>

              </div>
              <div style={{ float: "right" }}>

              </div>
            </div>

          </div>)
        }

        {this.state.isDownloadModalOpen && (
          <div className="modals"
            style={{
              position: 'fixed',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              backgroundColor: 'rgba(0, 0, 0, 0.5)',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              zIndex: 2000
            }}>
            <div className="modal-contents" style={{ 
              width: '80%', 
              maxWidth: '800px',
              maxHeight: '80vh',
              backgroundColor: 'white',
              borderRadius: '8px',
              padding: '20px',
              overflowY: 'auto'
            }}>
              <div style={{ 
                display: 'flex', 
                justifyContent: 'space-between', 
                alignItems: 'center',
                marginBottom: '20px',
                borderBottom: '2px solid #007bff',
                paddingBottom: '10px'
              }}>
                <h3 style={{ margin: 0, color: '#333' }}>
                  다운로드 파일 목록 (전체 {this.state.totalFiles}개 파일)
                </h3>
                <button 
                  onClick={this.closeDownloadModal}
                  style={{
                    background: 'none',
                    border: 'none',
                    fontSize: '24px',
                    cursor: 'pointer',
                    color: '#666'
                  }}>
                  ×
                </button>
              </div>
              
              <div style={{ marginBottom: '15px', color: '#666' }}>
                각 파일을 개별적으로 다운로드할 수 있습니다. 버튼을 클릭하여 다운로드하세요.
              </div>

              <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                {this.state.downloadUrls.map((urlItem, index) => (
                  <div 
                    key={index}
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      padding: '15px',
                      border: '1px solid #ddd',
                      borderRadius: '5px',
                      backgroundColor: '#f9f9f9'
                    }}>
                    <div style={{ flex: 1 }}>
                      <div style={{ fontWeight: 'bold', marginBottom: '5px' }}>
                        Part {urlItem.partNumber} / {this.state.downloadUrls.length}
                      </div>
                      <div style={{ fontSize: '14px', color: '#666' }}>
                        파일명: {urlItem.fileName}
                      </div>
                      <div style={{ fontSize: '12px', color: '#999', marginTop: '3px' }}>
                        포함된 파일 수: {urlItem.fileCount}개
                      </div>
                    </div>
                    <Button
                      color="primary"
                      onClick={() => this.downloadFile(urlItem.url, urlItem.fileName)}
                      style={{
                        marginLeft: '15px',
                        whiteSpace: 'nowrap'
                      }}>
                      다운로드
                    </Button>
                  </div>
                ))}
              </div>

              <div style={{ 
                marginTop: '20px', 
                paddingTop: '15px', 
                borderTop: '1px solid #ddd',
                textAlign: 'right'
              }}>
                <Button
                  color="secondary"
                  onClick={this.closeDownloadModal}>
                  닫기
                </Button>
              </div>
            </div>
          </div>
        )}

        <HeaderComponent signOut={this.props.cognito.signOut} setStage={this.props.setStage} stage={this.props.stage}></HeaderComponent>
        <div className="main_contents">
          <Container fluid>
            <Row>
              <div className="x_panel" style={{ alignItems: "center", display: "flex", justifyContent: "center" }}>
                <Col md={4}>
                  <Col md={3}>
                    <ButtonGroup>
                      <Button
                        color="primary"
                        onClick={() => {
                          this.exportToExcel();
                        }}
                      >
                        Export(Excel)
                      </Button>
                    </ButtonGroup>
                  </Col>
                  <Col md={3}>
                    <ButtonGroup>
                      <Button
                        color={this.state.onDownloadAll ? "secondary" : "primary"}
                        disabled={this.state.onDownloadAll}
                        onClick={() => {
                          this.downloadAll();
                        }}
                      >
                        {this.state.onDownloadAll ? (this.state.downloadProgress || "다운로드 준비 중") : "전체 다운로드"}
                      </Button>
                    </ButtonGroup>
                  </Col>

                </Col>

                <Col md={4} style={{ alignItems: "center", display: "flex", fontSize: 25, color: "black", fontWeight: 800, justifyContent: "center" }}>
                  {this.getModeKor()}
                </Col>

                <Col md={4}>

                  <Col md={4}>
                    <ButtonGroup>
                      <Button
                        color="info"
                        onClick={() => {
                          this.initializeDatatable();
                        }}
                      >
                        Refresh
                      </Button>
                    </ButtonGroup>
                  </Col>
                  <Col md={4}>
                    <Input value={this.state.selectedProjectName} onChange={(e) => this.onValueChanged("selectedProjectName", e.target.value)} id="selectedProjectName" name="selectedProjectName" type="select">

                      {this.state.project_list.map((item) => (
                        <option value={item.project_name}>{item.project_name}</option>
                      )
                      )}


                    </Input>
                  </Col>

                  <Col md={4}>
                    <Input value={this.state.selectedMode} onChange={(e) => this.onValueChanged("selectedMode", e.target.value)} id="selectedMode" name="selectedMode" type="select">
                      <option value={"all"}>목록 선택(전체보기)</option>
                      <option value={"accept"}>수락</option>
                      <option value={"reject"}>제외</option>
                      <option value={"ready"}>검수대기</option>



                    </Input>
                  </Col>
                </Col>
              </div>
              <div className="x_panel" style={{ alignItems: "center", display: "flex", justifyContent: "center" }}>
                <Table bordered style={{ width: "100%" }} innerRef={this.test} />
              </div>
            </Row>
          </Container>
        </div>
      </Fragment>
    );
  }
}

export default ProductAllPage;
